module.exports = __webpack_public_path__ + "static/media/xp-2.c31e72a6.png";